import { AppFeatures } from '@/types';
import {
  Inspection,
  Notes,
  WheelsAndTyres,
  Checklist,
  Damage,
  Documents,
  Charges,
  Images,
  PointInTimeReports,
  EventViewer,
  MOT,
} from './components/tabs';

export const tabs = [
  {
    title: 'inspection',
    component: Inspection,
    feature: AppFeatures.InspectionTab,
  },
  {
    title: 'notes',
    component: Notes,
    feature: AppFeatures.NotesTab,
  },
  {
    title: 'wheelsAndTyres',
    component: WheelsAndTyres,
    feature: AppFeatures.WheelsAndTyresTab,
  },
  {
    title: 'checklist',
    component: Checklist,
    feature: AppFeatures.ChecklistTab,
  },
  {
    title: 'damage',
    component: Damage,
    feature: AppFeatures.DamageTab,
  },
  {
    title: 'documents',
    component: Documents,
    feature: AppFeatures.DocumentsTab,
  },
  {
    title: 'charges',
    component: Charges,
    feature: AppFeatures.ChargesTab,
  },
  {
    title: 'images',
    component: Images,
    feature: AppFeatures.ImagesTab,
  },
  {
    title: 'pointInTimeReports',
    component: PointInTimeReports,
    feature: AppFeatures.PointInTimeReportsTab,
  },
  {
    title: 'eventViewer',
    component: EventViewer,
    feature: AppFeatures.EventViewerTab,
  },
  {
    title: 'mot',
    component: MOT,
    feature: AppFeatures.MotTab,
  },
];

export const fields = {
  basic: {
    regNumber: 'Reg Number',
    manufacturer: 'Make',
    model: 'Model',
    vin: 'VIN',
    colour: 'Color',
  },
  bannerBasic: {
    manufacturer: 'Make',
    model: 'Model',
    vin: 'VIN',
  },
  inspection: {
    inspectionDate: 'Inspection date',
    inspectionTime: 'Inspection time', // inspection date/time comes in inspectionDate field
    inspector: 'Inspector',
    inspectionLocation: 'Inspected At',
    id: 'Inspection ID',
    otherInspections: 'Other Inspections',
  },
  bannerInspection: {
    inspectionDateTime: 'Inspection date',
    inspectionLocation: 'Inspected At',
    inspectionStatus: 'Inspection status',
    mileage: 'Odometer',
  },
  inspectionStatus: {
    inspectionStatus: 'Inspection status',
    approvalDateTime: 'Approval date',
  },
};
